import { render, staticRenderFns } from "./ModalProcess.vue?vue&type=template&id=405d6b3c&scoped=true"
import script from "./ModalProcess.vue?vue&type=script&lang=js"
export * from "./ModalProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d6b3c",
  null
  
)

export default component.exports